import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';


const BillingAddressForm = () => {
  const [useProfileAddress, setUseProfileAddress] = useState(true);
  const [isBusinessAccount, setIsBusinessAccount] = useState(false);
  const [addressData, setAddressData] = useState({
    fullName: 'John Doe',
    email: 'john.doe@example.com',
    phone: '+91 98765 43210',
    addressLine1: '123 Business Park',
    addressLine2: 'Sector 18',
    city: 'Gurugram',
    state: 'Haryana',
    zipCode: '122001',
    country: 'India',
    gstNumber: ''
  });

  const countries = [
    { value: 'India', label: 'India' },
    { value: 'USA', label: 'United States' },
    { value: 'UK', label: 'United Kingdom' },
    { value: 'Canada', label: 'Canada' }
  ];

  const states = [
    { value: 'Haryana', label: 'Haryana' },
    { value: 'Delhi', label: 'Delhi' },
    { value: 'Maharashtra', label: 'Maharashtra' },
    { value: 'Karnataka', label: 'Karnataka' },
    { value: 'Tamil Nadu', label: 'Tamil Nadu' }
  ];

  const handleToggleProfileAddress = () => {
    setUseProfileAddress(!useProfileAddress);
    if (!useProfileAddress) {
      // Reset to profile data
      setAddressData({
        fullName: 'John Doe',
        email: 'john.doe@example.com',
        phone: '+91 98765 43210',
        addressLine1: '123 Business Park',
        addressLine2: 'Sector 18',
        city: 'Gurugram',
        state: 'Haryana',
        zipCode: '122001',
        country: 'India',
        gstNumber: addressData?.gstNumber
      });
    }
  };

  return (
    <div className="space-y-4">
      {/* Use Profile Address Toggle */}
      <div className="flex items-center justify-between bg-muted/30 rounded-lg p-4">
        <div className="flex items-center gap-3">
          <Icon name="User" size={20} className="text-primary" />
          <div>
            <p className="font-medium text-foreground">Use profile address</p>
            <p className="text-sm text-muted-foreground">Auto-fill from your profile</p>
          </div>
        </div>
        <button
          type="button"
          onClick={handleToggleProfileAddress}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
            useProfileAddress ? 'bg-primary' : 'bg-muted'
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              useProfileAddress ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>
      {/* Business Account Toggle */}
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="businessAccount"
          checked={isBusinessAccount}
          onChange={(e) => setIsBusinessAccount(e?.target?.checked)}
          className="h-4 w-4 rounded border-input text-primary focus:ring-2 focus:ring-primary"
        />
        <label htmlFor="businessAccount" className="text-sm font-medium text-foreground cursor-pointer">
          This is a business account
        </label>
      </div>
      {/* Address Form */}
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Full Name"
            placeholder="John Doe"
            value={addressData?.fullName}
            onChange={(e) => setAddressData({ ...addressData, fullName: e?.target?.value })}
            disabled={useProfileAddress}
            required
          />
          <Input
            label="Email"
            type="email"
            placeholder="john@example.com"
            value={addressData?.email}
            onChange={(e) => setAddressData({ ...addressData, email: e?.target?.value })}
            disabled={useProfileAddress}
            required
          />
        </div>

        <Input
          label="Phone Number"
          placeholder="+91 98765 43210"
          value={addressData?.phone}
          onChange={(e) => setAddressData({ ...addressData, phone: e?.target?.value })}
          disabled={useProfileAddress}
          required
        />

        <Input
          label="Address Line 1"
          placeholder="Street address, building name"
          value={addressData?.addressLine1}
          onChange={(e) => setAddressData({ ...addressData, addressLine1: e?.target?.value })}
          disabled={useProfileAddress}
          required
        />

        <Input
          label="Address Line 2"
          placeholder="Apartment, suite, unit (optional)"
          value={addressData?.addressLine2}
          onChange={(e) => setAddressData({ ...addressData, addressLine2: e?.target?.value })}
          disabled={useProfileAddress}
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Input
            label="City"
            placeholder="City"
            value={addressData?.city}
            onChange={(e) => setAddressData({ ...addressData, city: e?.target?.value })}
            disabled={useProfileAddress}
            required
          />
          <Select
            label="State"
            placeholder="Select state"
            options={states}
            value={addressData?.state}
            onChange={(value) => setAddressData({ ...addressData, state: value })}
            disabled={useProfileAddress}
            required
          />
          <Input
            label="ZIP Code"
            placeholder="122001"
            value={addressData?.zipCode}
            onChange={(e) => setAddressData({ ...addressData, zipCode: e?.target?.value })}
            disabled={useProfileAddress}
            required
          />
        </div>

        <Select
          label="Country"
          placeholder="Select country"
          options={countries}
          value={addressData?.country}
          onChange={(value) => setAddressData({ ...addressData, country: value })}
          disabled={useProfileAddress}
          required
        />

        {/* GST Number for Business Accounts */}
        {isBusinessAccount && (
          <div className="bg-accent/10 rounded-lg p-4 space-y-3">
            <div className="flex items-center gap-2">
              <Icon name="FileText" size={16} className="text-accent" />
              <span className="text-sm font-medium text-foreground">Business Details</span>
            </div>
            <Input
              label="GST Number"
              placeholder="22AAAAA0000A1Z5"
              value={addressData?.gstNumber}
              onChange={(e) => setAddressData({ ...addressData, gstNumber: e?.target?.value?.toUpperCase() })}
              description="Enter your 15-digit GST number for tax invoice"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default BillingAddressForm;